var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("iconfont icon-" + _vm.name + " " + (_vm.reverse ? ("reverse-" + _vm.reverse) : '')),style:({
    fontSize: (_vm.size + "px"),
    color: _vm.color
  })})}
var staticRenderFns = []

export { render, staticRenderFns }